import { useEffect, useRef, useState } from "react";
import { subscribeEvents, subscribeConnection } from "@/lib/events";

/**
 * Run `handler` for every real-time workspace event whose type is in `types`.
 * Pass an empty array to receive all types.
 */
export function useLiveEvents(types, handler) {
  const ref = useRef(handler);
  ref.current = handler;
  const key = Array.isArray(types) ? types.join("|") : String(types || "");
  useEffect(() => {
    const wanted = key ? key.split("|") : [];
    return subscribeEvents((event) => {
      if (wanted.length === 0 || wanted.includes(event.type)) ref.current(event);
    });
  }, [key]);
}

/** True while the SSE stream is connected. */
export function useLiveConnection() {
  const [live, setLive] = useState(false);
  useEffect(() => subscribeConnection(setLive), []);
  return live;
}
